import { updateScrollPosition } from "../community/feed";
import { IS_WEB } from "../config";
import {
  boardEl,
  boostersEl,
  communityFabEl,
  communityFeedEl,
  communityNavEl,
  editorBtnsEl,
  editorPendingTasksBtnEl,
  episodesCtrlEl,
  gameEl,
  gameIndicatorsEl,
  gameProfileEl,
  indicatorsBgEl,
  indicatorsEl,
  levelIndicatorEl,
  levelLivesIndicatorsEl,
  levelSeparatorEl,
  livesCounterEl,
  livesHeartEl,
  loseLifeDialogEl,
  mainMenuEl,
  mapEl,
  menuBgEl,
  menuDifficultyBtnEl,
  menuDividerNavEl,
  menuEarnBtnEl,
  menuEl,
  menuCommunityBtnEl,
  menuMainMenuBtnEl,
  menuMapBtnEl,
  menuOpenBtnEl,
  menuRmAdsBtnEl,
  playLoginBtnEl,
  profileEl,
  showTipBtnEl,
  svgContainerEl,
  noSignalIndicatorEl,
  menuAutoTranslateBtnEl,
} from "../elements";
import {
  createBackButton,
  createBoosters,
  createIndicator,
  createIndicatorSmall,
  removeBackButton,
} from "../game";
import { removeGameEventListeners } from "../game/editor";
import { handleAds } from "../iap";
import { getLogger } from "../logging";
import { hideEndEpisodes } from "../map";
import { updateScrollPositionProfile } from "../profile";
import store from "../store";
import {
  autoTranslateElements,
  shouldEnableTranslationFeature,
} from "../translate";

const log = getLogger("Styles");

const DEBUG_LOGS = __DEV__;

function atGame() {
  return (
    atGameClassic() || atGameStory() || atGameEditor() || atGameCommunity()
  );
}

function atGameEditor() {
  return store.screenName == "game_editor";
}

function atGameClassic() {
  return store.screenName == "game_classic";
}

function atGameCommunity() {
  return store.screenName == "game_community";
}

function atGameStory() {
  return store.screenName == "game";
}

function atMainMenu() {
  return store.screenName == "main_menu";
}

function atMap() {
  return store.screenName == "map";
}

function atProfile() {
  return store.screenName == "profile";
}

function atCommunityFeed() {
  return store.screenName == "community_feed";
}

function atLoseLifeDialog() {
  return store.screenName == "lose_life_dialog";
}

function atMenu() {
  return store.screenName == "menu";
}

function atMenuFromCommunityFeed() {
  return atMenu() && store.screenNamePrev == "community_feed";
}

function atMenuFromProfile() {
  return atMenu() && store.screenNamePrev == "profile";
}

function atMenuFromGame() {
  return atMenu() && ["game", "game_classic"].includes(store.screenNamePrev);
}

function atMenuFromGameEditor() {
  return atMenu() && store.screenNamePrev == "game_editor";
}

function atMenuFromGameCommunity() {
  return atMenu() && store.screenNamePrev == "game_community";
}

function atMenuFromMap() {
  return atMenu() && store.screenNamePrev == "map";
}

function atMenuFromMainMenu() {
  return atMenu() && store.screenNamePrev == "main_menu";
}

function atMenuFromGameClassic() {
  return atMenu() && store.screenNamePrev == "game_classic";
}
function atMenuFromGameStory() {
  return atMenu() && store.screenNamePrev == "game";
}

function atSkinPicker() {
  return store.screenName == "skin_picker";
}

const removeBosterEls = () => {
  boostersEl.style.display = "none";
  const lockEls = document.getElementsByClassName("lock");
  const boosterCounterEls = document.getElementsByClassName("booster-counter");
  while (lockEls[0]) lockEls[0].parentNode.removeChild(lockEls[0]);
  while (boosterCounterEls[0])
    boosterCounterEls[0].parentNode.removeChild(boosterCounterEls[0]);
};

export function updateStyles() {
  //   if (atGameEditorPlaying()) {
  //     DEBUG_LOGS && log.debug("atGameEditorPlaying");
  //     editorBtnsEl.style.display = "none";
  //   }
  //     else {
  //     editorBtnsEl.style.display = "none";
  //     }
  if (atMenu()) {
    menuEl.style.display = "initial";
    menuBgEl.style.display = "initial";
  } else {
    menuEl.style.display = "none";
    menuBgEl.style.display = "none";
  }
  if (atGame() || atSkinPicker()) {
    DEBUG_LOGS && log.debug("atGame");
    gameEl.style.filter = "none";
    indicatorsEl.style.filter = "none";
    menuOpenBtnEl.style.filter = "none";
    boardEl.style.display = "initial";
    episodesCtrlEl.style.display = "none";
    boardEl.style.display = "initial";
    boostersEl.style.display = "initial";
    indicatorsBgEl.style.display = "initial";
    indicatorsEl.style.background = "none";
    indicatorsEl.style.border = "none";
    gameIndicatorsEl.style.display = "initial";
    indicatorsEl.style.display = "initial";
    levelLivesIndicatorsEl.style.display = "initial";
  }
  if (atGameClassic() || atGameStory()) {
    createIndicator();
  } else if (!atGameCommunity()) {
    indicatorsBgEl.style.display = "none";
    indicatorsEl.style.display = "none";
  }
  if (!atGameStory() && !atGameCommunity()) {
    removeBosterEls();
  } else {
    createBoosters();
  }
  if (atGameCommunity()) {
    levelLivesIndicatorsEl.style.display = "none";
    gameIndicatorsEl.firstElementChild.style.marginLeft = 0;
    gameIndicatorsEl.firstElementChild.style.marginTop =
      "calc(0.1 * var(--scale))";
    createIndicatorSmall();
    createBackButton();
  } else {
    gameIndicatorsEl.firstElementChild.style.marginLeft =
      "calc(0.8 * var(--scale))";
    gameIndicatorsEl.firstElementChild.style.marginTop =
      "calc(0.35 * var(--scale))";
    removeBackButton();
  }
  if (atGameStory()) {
    DEBUG_LOGS && log.debug("atGameStory");
    if (menuDividerNavEl) menuDividerNavEl.style.display = "block";
  }
  if (atGameClassic() || atMenuFromGameClassic()) {
    DEBUG_LOGS && log.debug("atGameClassic or atMenuFromGameClassic");
    if (store.classicLevelIdx == 1) {
      levelIndicatorEl.style.fontSize = "calc(3 * var(--scale) * 0.9)";
      gameIndicatorsEl.style.marginTop = "calc(0.65 * var(--scale))";
    } else {
      levelIndicatorEl.style.fontSize =
        "calc(3 * var(--scale) * var(--font-scale))";
      gameIndicatorsEl.style.marginTop = "calc(0.35 * var(--scale))";
    }
  }
  if (atGameStory() || atMenuFromGameStory()) {
    DEBUG_LOGS && log.debug("atGameStory or atMenuFromGameStory");
    menuMapBtnEl.style.display = "block";
  } else {
    menuMapBtnEl.style.display = "none";
  }
  if (atGameStory() || atMenuFromGameStory() || atMap() || atMenuFromMap()) {
    __DEV__ &&
      log.debug("atGameStory or atMenuFromGameStory or atMap or atMenuFromMap");
    if (!IS_WEB || __DEV__) menuEarnBtnEl.style.display = "block";
  } else {
    menuEarnBtnEl.style.display = "none";
  }
  if (atGameCommunity()) {
    gameProfileEl.style.display = "initial";
  } else {
    gameProfileEl.style.display = null;
  }
  if (atMenuFromMainMenu()) {
    DEBUG_LOGS && log.debug("atMenuFromMainMenu");
    menuMainMenuBtnEl.style.display = "none";
  } else {
    menuMainMenuBtnEl.style.display = "block";
  }
  if (
    atMenuFromMainMenu() ||
    atMenuFromCommunityFeed() ||
    atMenuFromProfile() ||
    atMenuFromMap() ||
    atMenuFromGameClassic() ||
    atMenuFromGameEditor()
  ) {
    if (shouldEnableTranslationFeature())
      menuAutoTranslateBtnEl.style.display = "block";
  } else {
    menuAutoTranslateBtnEl.style.display = "none";
  }

  if (atGameClassic()) {
    DEBUG_LOGS && log.debug("atGameClassic");
    livesHeartEl.style.display = "none";
    livesCounterEl.style.display = "none";
    levelSeparatorEl.style.display = "none";
    menuOpenBtnEl.style.display = "initial";
    if (menuDividerNavEl) menuDividerNavEl.style.display = "none";
    menuDifficultyBtnEl.style.display = "block";
    menuDifficultyBtnEl.innerHTML = `🔢 Difficulty: ${
      ["Easy", "Medium", "Hard"][store.classicLevelIdx]
    }`;
    autoTranslateElements(menuDifficultyBtnEl);
  }
  if (atGame() || atMenuFromGame() || atSkinPicker()) {
    DEBUG_LOGS && log.debug("atGame or atMenuFromGame");
    svgContainerEl.style.backgroundColor = store.themes[2];
    menuOpenBtnEl.style.backgroundColor = store.themes[10];
    svgContainerEl.style.backgroundImage = 'url("img/bg/game.jpg")';
  } else {
    svgContainerEl.style.backgroundColor = store.themes[10];
  }
  if ((atGame() || atMenuFromGame()) && !atGameEditor()) {
    DEBUG_LOGS && log.debug("atGame or atMenuFromGame and not atGameEditor");
  }
  if (atGameEditor()) {
    DEBUG_LOGS && log.debug("atGameEditor");
    editorBtnsEl.style.display = null;
    editorPendingTasksBtnEl.style.display = null;
    menuOpenBtnEl.style.display = "initial";
  } else {
    editorBtnsEl.style.display = "none";
    editorPendingTasksBtnEl.style.display = "none";
    removeGameEventListeners();
  }
  if (atMenuFromGameEditor() || atMenuFromGameCommunity()) {
    menuCommunityBtnEl.style.display = "block";
  } else {
    menuCommunityBtnEl.style.display = "none";
  }
  if (atMainMenu()) {
    DEBUG_LOGS && log.debug("atMainMenu");
    hideEndEpisodes();
    svgContainerEl.style.backgroundImage = 'url("img/bg/5.jpg")';
    mainMenuEl.style.display = "flex";
    showTipBtnEl.style.display = "none";
    indicatorsEl.style.display = "none";
    episodesCtrlEl.style.display = "none";
    livesHeartEl.style.display = "initial";
    livesCounterEl.style.display = "initial";
    levelSeparatorEl.style.display = "initial";
    // menuOpenBtnEl.style.display = "none";
    editorBtnsEl.style.display = "none";
    if (store.user.uid) playLoginBtnEl.style.display = "none";
    menuOpenBtnEl.style.backgroundColor = "rgba(207, 200, 196, 0.5)";
  } else {
    mainMenuEl.style.display = "none";
    // menuOpenBtnEl.style.display = "initial";
    menuOpenBtnEl.style.backgroundColor = store.themes[10];
  }
  if (atMap()) {
    DEBUG_LOGS && log.debug("atMap");
    menuOpenBtnEl.style.backgroundColor = store.themes[2];
    svgContainerEl.style.backgroundImage = `url("img/bg/episode-${
      store.episodeIdx + 1
    }.jpg")`;
    gameEl.style.height = null;
    gameEl.style.width = null;
    gameEl.style.paddingBottom = null;
    gameEl.style.paddingTop = null;
    const lockEls = document.getElementsByClassName("lock");
    const boosterCounterEls =
      document.getElementsByClassName("booster-counter");
    while (lockEls[0]) lockEls[0].parentNode.removeChild(lockEls[0]);
    while (boosterCounterEls[0])
      boosterCounterEls[0].parentNode.removeChild(boosterCounterEls[0]);
    levelLivesIndicatorsEl.style.display = "initial";
    mapEl.style.display = "initial";
    gameIndicatorsEl.style.display = "none";
    indicatorsEl.style.display = "initial";
    indicatorsEl.style.backgroundColor = "#EDF3BF";
    indicatorsEl.style.borderWidth = "0.4vmin";
    indicatorsEl.style.borderStyle = "solid";
    indicatorsEl.style.borderColor = "black";
    indicatorsEl.style.top = "2vmin";
    indicatorsEl.style.left = "2vmin";
    indicatorsEl.style.filter = "none";
    indicatorsBgEl.style.display = "none";
    menuOpenBtnEl.style.display = "initial";
    showTipBtnEl.style.display = "none";
    gameEl.style.filter = "none";
    episodesCtrlEl.style.display = "flex";
    boardEl.style.display = "none";
    boostersEl.style.display = "none";
    menuRmAdsBtnEl.style.display = "none";
    menuDifficultyBtnEl.style.display = "none";
    menuDifficultyBtnEl.innerHTML = "";
    if (menuDividerNavEl) menuDividerNavEl.style.display = "none";
  } else {
    mapEl.style.display = "none";
  }
  if (atLoseLifeDialog()) {
    DEBUG_LOGS && log.debug("atLoseLifeDialog");
    loseLifeDialogEl.style.display = "initial";
  } else {
    loseLifeDialogEl.style.display = null;
  }
  if (atCommunityFeed() || atProfile()) {
    DEBUG_LOGS && log.debug("atCommunityFeed or atProfile");
    communityFabEl.style.display = "initial";
  } else {
    communityFabEl.style.display = "none";
  }
  if (atCommunityFeed()) {
    DEBUG_LOGS && log.debug("atCommunityFeed");
    communityFeedEl.style.display = "flex";
    communityNavEl.style.display = "flex";
    communityFeedEl.style.backgroundImage =
      'url("img/bg/community_levels.jpg")';
    communityFeedEl.style.backgroundSize = "cover";
    communityFeedEl.style.backgroundPosition = "center";
    svgContainerEl.style.display = "none";
    gameEl.style.display = "none";
    handleAds();
    updateScrollPosition();
  } else {
    communityFeedEl.style.display = "none";
    svgContainerEl.style.display = "initial";
    gameEl.style.display = "initial";
    communityNavEl.style.display = "none";
  }
  if (atProfile()) {
    DEBUG_LOGS && log.debug("atProfile");
    profileEl.style.display = "initial";
    updateScrollPositionProfile();
  } else {
    profileEl.style.display = "none";
  }
  if (atGame() || atMainMenu() || atMap() || atMenu() || atLoseLifeDialog()) {
    noSignalIndicatorEl.style.visibility = "hidden";
  } else {
    noSignalIndicatorEl.style.visibility = "visible";
  }
  if (atSkinPicker()) {
    menuOpenBtnEl.style.display = "none";
  } else {
    gameEl.style.width = null;
    gameEl.style.right = null;
    svgContainerEl.style.width = "100%";
    svgContainerEl.style.right = null;
  }
}
